<template>
  <modal>
    <div class="modal-header">
      <h4 class="title">เพิ่มรายการที่เกี่ยวข้อง</h4>
      <button
        @click.stop="onClose"
        type="button"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <!-- <form> -->
      <div class="modal-body">
        <FormGroup class="mb-0">
          <h5 class="name">เลือกรายการ</h5>
          <input class="form-control" :placeholder="'ค้นหารายการ'" v-model="filter.q" @keyup.enter="onSearchPrograms"/>
          <div class="wrapper-container">
            <div class="program-list-container" v-if="hasProgramsOption && !isLoading">
              <div class="program-item"
                v-for="(program, index) in programs"
                :key="index"
                @click="onSelectProgram(program)">
                <div class="program-image">
                  <ImageView
                    :source="program.coverImage"
                    :imageSize="'cover160w90h'" />
                </div>
                <div class="program-title">{{program.title}}</div>
                <div class="checkbox-container">
                  <input
                    type="checkbox"
                    class="styled-checkbox"
                  />
                  <span class="checkmark" :class="{ checked: hasProgram(program)}">
                    <i class="fa fa-check check-icon" />
                  </span>
                </div>
              </div>
            </div>
            <div class="empty-state-container center-container" v-if="!hasProgramsOption && !isLoading">
              <div class="no-program empty-state">
                ไม่พบรายการที่ค้นหา
              </div>
            </div>
            <div class="spinner-container center-container" v-if="isLoading">
              <i class="fa fa-spinner fa-3x fa-spin"/>
            </div>
          </div>
          <div class="pagination-container">
            <PaginationModal
              :lastPage="lastPage"
              :currentPage.sync="filter.page"
              v-if="isShowPagination"
            />
          </div>
        </FormGroup>
      </div>
      <div class="modal-footer">
       <!-- <div class="error-text" v-if="errorCode && !errorVideoTitle">บันทึกไม่สำเร็จกรุณาติดต่อผู้ดูแลระบบ (code: {{errorCode}})</div>
       <div class="error-text" v-if="errorVideoTitle">มีรายการ "{{errorVideoTitle}}" อยู่ในระบบแล้ว</div> -->
        <button
          class="btn btn-primary"
          type="button"
          @click="onSubmit"
          :disabled="!isValid">
          <i class="fa fa-spinner fa-spin mr-1" v-if="isSaving"/>เลือก
          <span v-if="programCount"> {{programCount}} รายการ</span>
        </button>
      </div>
    <!-- </form> -->
  </modal>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import PaginationModal from '@/components/PaginationModal.vue';
import ImageView from '@/image/ImageView.vue';
import { loadPrograms } from './api';

export default {
  components: {
    Modal,
    FormGroup,
    ImageView,
    PaginationModal,
  },
  props: {
    customRelatedProgramIds: {
      type: Array,
      default: () => [],
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      programs: [],
      filter: {
        q: '',
        page: 1,
      },
      selectedProgram: [],
      isSaving: false,
      isLoading: false,
      lastPage: 1,
    };
  },
  created() {
    this.loadPrograms();
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
    }),
    isShowPagination() {
      return this.lastPage > 1;
    },
    programCount() {
      return this.selectedProgram.length;
    },
    isValid() {
      if (this.selectedProgram && this.selectedProgram.length === 0) {
        return false;
      }
      return true;
    },
    hasProgramsOption() {
      return this.programs && this.programs.length > 0;
    },
    page() {
      return this.filter.page;
    },
  },
  watch: {
    page(newPage) {
      const filter = {
        ...this.filter,
        page: newPage,
      };
      this.loadPrograms(filter);
    },
  },
  methods: {
    async loadPrograms(filter) {
      this.isLoading = true;
      const response = await loadPrograms(filter);
      const filterProgram = _.filter(response.data.data, (program) => {
        if (program.id !== this.currentProgram.id && !this.customRelatedProgramIds.includes(program.id)) {
          return program;
        }
      });
      this.programs = filterProgram;
      this.lastPage = response.data.lastPage;
      this.isLoading = false;
    },
    onSearchPrograms() {
      this.filter.page = 1;
      this.loadPrograms(this.filter);
    },
    hasProgram(program) {
      return this.selectedProgram.includes(program);
    },
    onSubmit() {
      this.$emit('update:customRelatedPrograms', this.selectedProgram);
      this.onClose();
    },
    onSelectProgram(program) {
      this.selectedProgram.push(program);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';


.error-text {
  font-size: 80%;
  color: #dc3545;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.wrapper-container {
  height: 300px;
  border-bottom: 0.5px solid $gray-200;
  border-left: 0.5px solid $gray-200;
  border-right: 0.5px solid $gray-200;
  overflow: auto;

  .program-item {
    display: flex;
    align-items: center;
    padding: 0.75 * $spacer $spacer;
    cursor: pointer;
    .program-image {
      width: 25%;
    }
    .program-title {
      width: 60%;
      padding-left: $spacer;
    }
    .checkbox-container {
      margin-left: auto;
      position: relative;
      height: 30px;
      width: 30px;
      .styled-checkbox {
        position: relative;
        opacity: 0;
        height: 0;
        width: 0;
      }
      .checkmark {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        width: 30px;
        top: 0;
        right: 0;
        border-radius: 30px;
        border: 2px solid $gray-300;
        .check-icon {
          display: none;
        }
      }
      .checked {
        transition: all 0.2s ease-in;
        border: 2px solid $success;
        color: $success;
        .check-icon {
          display: inline;
        }
      }
    }
  }
  .program-item:hover {
    transition: all 0.2s ease-in;
    background-color: $gray-100;
  }
  .center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }
}

.pagination-container {
  margin-top: $spacer;
  // height: 40px;
}

@media (max-width: 575.98px) {
  .program-title {
    font-size: $font-size-base * 0.8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

</style>
